import { QUERY_KEYS } from "@config/constant";

export const goalSignalQueryKeys = {
  all: [QUERY_KEYS.GOAL_SIGNALS] as const,
  list: (goalId: string, params: { limit: number; nextToken?: string }) =>
    [QUERY_KEYS.GOAL_SIGNALS, goalId, params] as const,
};
